/*
 * ====================================================================================================
 * WARNING: BACKEND-COPIED DTO FILE
 * THIS FILE IS COPIED FROM THE BACKEND.
 * DO NOT MODIFY THIS FILE MANUALLY IN FRONTEND CODE.
 * IT MAY BE DELETED, REGENERATED, OR REPLACED AT ANY TIME.
 * ====================================================================================================
 */

import { CategoryOfService, SwissReductionCard } from "../../../cff-pricing.types";

/**
 * Optional pricing preferences forwarded to Swiss pricing/offer providers.
 *
 * These fields are hints, not guarantees. Providers may ignore unsupported values.
 */
export class ItineraryPricingPreferencesDTO {

    /**
     * Swiss reduction card profile sent to CFF pricing providers.
     * Example: half-fare
     * Default: none
     * Enum: [ "none", "half-fare", "ga" ] satisfies SwissReductionCard[]
     */
    swissReductionCard?: SwissReductionCard;

    /**
     * Requested CFF travel class (`"1"` for first class, `"2"` for second class).
     * Example: 1
     * Default: 2
     * Enum: [ "1", "2" ] satisfies CategoryOfService[]
     */
    categoryOfService?: CategoryOfService;

    /**
     * Passenger date of birth (`YYYY-MM-DD`) used to price age-dependent CFF fares.
     * Optional on the public offer endpoint; the authoritative passenger DOB is
     * always the authenticated user's at prebooking time.
     * Example: 1990-05-17
     * Format: date
     */
    passengerBirthdate?: string;

    /**
     * When true, allows supersaver fares if providers return eligible offers.
     * Example: true
     * Default: false
     */
    useSuperSaverIfAvailable?: boolean;

    /**
     * When true, Swiss CFF trip-offers requests include `bikes=PersonalBike` so ticketing returns bike-capable products.
     * Example: true
     * Default: false
     */
    transportPersonalBike?: boolean;

}
